export enum FinishTypes {
  STEEL = 'STEEL',
  STEEL_PET55 = 'STEELPET55',
  RVS304_ROUND_BRUSH = 'RVS304ROUNDBRUSH',
  RVS304_LINEN = 'RVS304LINEN',
  RVS304_COLLED_ROLLED = 'RVS304COLLEDROLLED',
  RVS304_LINE_BRUSH = 'RVS304LINEBRUSH',
  RVS304_DESIGN_5WL = 'RVS304DESIGN5WL',
  RVS316_ROUND_BRUSH = 'RVS316ROUNDBRUSH',
}
